import React, {Component} from 'react';
import {defineMessages} from 'react-intl';

import CenteredMessage from '@swipe-guide/clients-shared/components/CenteredMessage';
import {FormattedMessage} from '@swipe-guide/clients-shared/components/FormattedComponents';

import {StyledError} from './styles';

const messages = defineMessages({
  error_somethingSnapped: {
    id: 'error_somethingSnapped',
    defaultMessage: 'Upps, something snapped'
  }
});

class ErrorComponent extends Component {
  render() {
    return (
      <StyledError>
        <CenteredMessage icon={'warning'}>
          <FormattedMessage {...messages.error_somethingSnapped} />
        </CenteredMessage>
      </StyledError>
    );
  }
}

export default ErrorComponent;
